import HNSColors from "../../../../../../ui library/HNSColors";

const getButtonSizes = (isNarrow) => ({
  viewWidth: isNarrow ? "166px" : "210px",
  callWidth: isNarrow ? "135px" : "210px",
  fontSize: isNarrow ? "12px" : "14px",
});

const dropdownButtonBase = (fontSize) => ({
  height: "43px",
  fontSize,
  fontWeight: 600,
  paddingX: "18px",
  textTransform: "none",
  borderRadius: "999px",
  justifyContent: "space-between",
});

const callButton = (isNarrow) => {
  const { callWidth, fontSize } = getButtonSizes(isNarrow);
  return {
    ...dropdownButtonBase(fontSize),
    background: HNSColors.primary[400],
    width: callWidth,
    fontWeight: 400,
    "&:hover": {
      background: HNSColors.primary[300],
    },
    "&.Mui-disabled": {
      background: HNSColors.neutrals[800],
      color: HNSColors.neutrals[500],
      "& .MuiSvgIcon-root": { color: HNSColors.neutrals[500] },
      "& svg": { color: HNSColors.neutrals[500] },
    },
  };
};

const viewButton = (isNarrow) => {
  const { viewWidth, fontSize } = getButtonSizes(isNarrow);
  return {
    ...dropdownButtonBase(fontSize),
    background: HNSColors.tertiary[600],
    width: viewWidth,
    fontWeight: 400,
    "&:hover": {
      background: HNSColors.tertiary[500],
    },
    "&.Mui-disabled": {
      background: HNSColors.neutrals[800],
      color: HNSColors.neutrals[500],
      "& .MuiSvgIcon-root": { color: HNSColors.neutrals[500] },
      "& svg": { color: HNSColors.neutrals[500] },
    },
  };
};

const menuPaper = (isNarrow) => ({
  borderRadius: "12px",
  boxShadow: "0px 12px 30px rgba(10, 46, 112, 0.2)",
  py: "0px",
  mt: 1.5,
  minWidth: isNarrow ? "120px" : "210px",
  "& .MuiMenu-list": { padding: "0" },
});

const menuItem = {
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "12px",
  fontSize: "14px",
  fontWeight: 500,
  color: "#1D2C4A",
  padding: "14px 22px",
  "&:hover": {
    backgroundColor: HNSColors.tertiary[900],
    color: HNSColors.primary[500],
  },
};

const actionButtonsStyles = {
  getButtonSizes,
  dropdownButtonBase,
  callButton,
  viewButton,
  menuPaper,
  menuItem,
};

export default actionButtonsStyles;
export const VIEW_CONFIG_BY_VARIANT = {
  client: {
    iconName: "his-file-search",
    iconSx: { width: "22px" },
    className:
      "inline-flex items-center justify-center rounded-[500px] px-[18px] py-[10px] text-center font-['Roboto'] normal-case leading-none tracking-normal text-white !shadow-none",
  },
  lawFirm: {
    iconName: "his-person",
    iconSx: { width: "18px", viewBox: "-3 0 30 30" },
    className:
      "inline-flex items-center justify-center gap-1 rounded-[500px] px-[18px] py-[10px] text-center font-['Roboto'] normal-case leading-none tracking-normal text-white !shadow-none",
  },
};
